if (!customElements.get('custom-header')) {
  class CustomHeader extends HTMLElement {
    constructor() {
      super();
      this.onScrollHandler = this.onScroll.bind(this);
      this.onLinkClickHandler = this.closeMenu.bind(this);
    }

    connectedCallback() {
      this.burger = this.querySelector('.custom-header__burger');
      this.nav = this.querySelector('.custom-header__nav');
      this.menuLinks = this.querySelectorAll('.custom-header__link');
      
      this.isSticky = this.classList.contains('custom-header--sticky');

      if (this.burger && this.nav) {
        this.burger.addEventListener('click', this.toggleMenu.bind(this));
      }

      if (this.menuLinks.length) {
        this.menuLinks.forEach(link => {
          link.addEventListener('click', this.onLinkClickHandler);
        });
      }

      if (this.isSticky) {
        window.addEventListener('scroll', this.onScrollHandler, { passive: true });
        this.onScroll(); 
      }

      this.initNavigationHighlight();
    }

    disconnectedCallback() {
      if (this.burger) {
        this.burger.removeEventListener('click', this.toggleMenu.bind(this));
      }
      if (this.menuLinks.length) {
        this.menuLinks.forEach(link => {
          link.removeEventListener('click', this.onLinkClickHandler);
        });
      }
      if (this.isSticky) {
        window.removeEventListener('scroll', this.onScrollHandler);
      }
      if (this.observer) {
        this.observer.disconnect();
      }
      document.body.classList.remove('overflow-hidden');
    }

    initNavigationHighlight() {
      const menuItems = this.querySelectorAll('.custom-header__link');
      const sections = document.querySelectorAll('section[id]');

      if (!sections.length || !menuItems.length) return;

      const setActiveItem = (id) => {
        menuItems.forEach((item) => {
          item.classList.toggle(
            'is-active',
            item.getAttribute('href') === `#${id}`
          );
        });
      };

      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              setActiveItem(entry.target.id);
            }
          });
        },
        {
          rootMargin: '-30% 0px -60% 0px',
        }
      );

      sections.forEach((section) => this.observer.observe(section));
    }

    toggleMenu() {
      const isExpanded = this.burger.getAttribute('aria-expanded') === 'true';
      this.burger.setAttribute('aria-expanded', !isExpanded);
      this.nav.classList.toggle('is-open');
      document.body.classList.toggle('overflow-hidden');
    }

    closeMenu() {
      if (this.burger && this.nav && this.nav.classList.contains('is-open')) {
        this.burger.setAttribute('aria-expanded', 'false');
        this.nav.classList.remove('is-open');
        document.body.classList.remove('overflow-hidden');
      }
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      
      if (scrollTop > 35) {
        this.classList.add('is-scrolled');
      } else {
        this.classList.remove('is-scrolled');
      }
    }
  }

  customElements.define('custom-header', CustomHeader);
}